import { useCategories } from '../api'
import { NOT_APPLICABLE, OTHER_CATEGORY } from '../config'
import { getDisplayCategory, getDisplayLabel } from '../lib'
import type { Subcategory } from './types'

export function useSubcategories(): Subcategory[] {
  const {
    data: { categories },
  } = useCategories()
  return [
    ...categories
      .map(({ subcategories }) => subcategories)
      .flat()
      .map(({ label, metadata, description, deprecated, superseded_by }) => ({
        label,
        displayLabel: getDisplayCategory(metadata, label),
        description,
        deprecated: !!deprecated,
        supersededBy: superseded_by ?? null,
        metadata: {
          phase: {
            label: metadata?.phase ?? NOT_APPLICABLE,
            displayLabel: metadata?.phase ? getDisplayLabel(metadata.phase) : NOT_APPLICABLE,
          },
          outcome: {
            label: metadata?.outcome ?? NOT_APPLICABLE,
            displayLabel: metadata?.outcome ? getDisplayLabel(metadata.outcome) : NOT_APPLICABLE,
          },
          reason: {
            label: metadata?.reason ?? NOT_APPLICABLE,
            displayLabel: metadata?.reason ? getDisplayLabel(metadata.reason) : NOT_APPLICABLE,
          },
        },
      })),
    OTHER_CATEGORY,
  ]
}
